// @flow
import BaseCollection from "../../base/BaseCollection";
import ConstraintModel from "./ConstraintModel";

import { getSetting } from "../../../constants/Settings";

import type { IConstraintModel } from "../../types";

/**
 * Attribute constraints
 */
export default class ConstraintCollection extends BaseCollection<IConstraintModel> {
  /**
   * Add constraint
   */
  addConstraint(
    id: string,
    validateMethod: ?Function,
    defaultMessage: ?string,
    data: ?Object,
    useClientsideValidation: boolean = getSetting("USE_CLIENTSIDE_VALIDATION"),
  ) {
    this.add(
      new ConstraintModel(
        id,
        validateMethod,
        defaultMessage,
        data,
        useClientsideValidation,
      ),
    );
  }

  /**
   * Validate if complete collection is valid
   */
  validate(value: any): boolean {
    return (
      this.isEmpty ||
      this.collection.every((constraint) => constraint.validate(value))
    );
  }

  /**
   * Indicates if a mandatory constraint exists in the collection
   */
  hasMandatoryConstraint(): boolean {
    return this.collection.some(
      (constraint) => constraint.isMandatoryConstraint,
    );
  }

  /**
   * Retrieve all invalid constraints
   */
  invalidConstraints(value: any): Array<IConstraintModel> {
    if (value === "" && !this.hasMandatoryConstraint()) {
      return [];
    }

    return this.collection.filter(
      (constraint) => constraint.validate(value) === false,
    );
  }
}
